import { render, staticRenderFns } from "./r-webcomponent.vue?vue&type=template&id=6354e34d&shadow"
import script from "./r-webcomponent.vue?vue&type=script&lang=js&shadow"
export * from "./r-webcomponent.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports